import { Stack } from '@mui/material';
import { Sections } from './Sections';
import { Title } from './Title';
import { useAppSelector, useDictionary, useDispatchApp } from 'Hooks';
import { useCallback, useEffect, useState } from 'react';
import { Loader } from 'Components';
import { getPersonalDetails } from 'API/personalDetails';
import { setPersonalDetails } from 'Store/PersonalDetailsSlice';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { CustomMetaTitle } from 'Components/CustomMetaTitle';

interface IUpdatePersonalDetails {
  nextStep: () => void;
}

export const UpdatePersonalDetails = ({ nextStep }: IUpdatePersonalDetails) => {
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatchApp();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.UpdatePersonalDetails
  );

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const initializePersonalDetails = useCallback(async () => {
    setIsLoading(true);
    const result = await getPersonalDetails();
    if (result) {
      dispatch(setPersonalDetails(result));
    }
    setIsLoading(false);
  }, [dispatch]);

  useEffect(() => {
    initializePersonalDetails();
  }, [initializePersonalDetails, imposterId]);

  return (
    <>
      <CustomMetaTitle title={dictionary.title} />
      {isLoading ? (
        <Loader />
      ) : (
        <Stack
          alignItems='center'
          gap='40px'
          sx={{ '.MuiFormHelperText-root': { fontSize: '14px' } }}
        >
          <Title />
          <Sections nextStep={nextStep} />
        </Stack>
      )}
    </>
  );
};
